// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.5 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #eeeeee; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Montserrat, sans-serif, Montserrat, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #bdbdbd; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(33 150 243 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(33 150 243 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}
@media (min-width: 720px) {

  .\\!container {
    max-width: 720px !important;
  }

  .container {
    max-width: 720px;
  }
}
@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}
@media (min-width: 960px) {

  .\\!container {
    max-width: 960px !important;
  }

  .container {
    max-width: 960px;
  }
}
@media (min-width: 1024px) {

  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .\\!container {
    max-width: 1536px !important;
  }

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.\\!invisible {
  visibility: hidden !important;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-y-1 {
  top: 0.25rem;
  bottom: 0.25rem;
}
.-bottom-0 {
  bottom: -0px;
}
.-bottom-0\\.5 {
  bottom: -0.125rem;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-1\\.5 {
  bottom: -0.375rem;
}
.-left-1 {
  left: -0.25rem;
}
.-left-\\[110px\\] {
  left: -110px;
}
.-left-\\[200px\\] {
  left: -200px;
}
.-right-\\[2px\\] {
  right: -2px;
}
.-top-0 {
  top: -0px;
}
.-top-0\\.5 {
  top: -0.125rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-10 {
  top: -2.5rem;
}
.-top-11 {
  top: -2.75rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-2\\.5 {
  top: -0.625rem;
}
.-top-4 {
  top: -1rem;
}
.-top-5 {
  top: -1.25rem;
}
.-top-\\[15px\\] {
  top: -15px;
}
.-top-\\[1px\\] {
  top: -1px;
}
.-top-\\[7px\\] {
  top: -7px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-7 {
  bottom: 1.75rem;
}
.bottom-\\[14\\%\\] {
  bottom: 14%;
}
.bottom-\\[4\\%\\] {
  bottom: 4%;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\.5 {
  left: 0.375rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\/4 {
  left: 50%;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-\\[14\\%\\] {
  left: 14%;
}
.left-\\[2\\%\\] {
  left: 2%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-\\[14\\%\\] {
  right: 14%;
}
.right-\\[2\\%\\] {
  right: 2%;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-2\\/4 {
  top: 50%;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-7 {
  top: 1.75rem;
}
.top-\\[10px\\] {
  top: 10px;
}
.top-\\[14\\%\\] {
  top: 14%;
}
.top-\\[4\\%\\] {
  top: 4%;
}
.top-\\[calc\\(100\\%\\+6px\\)\\] {
  top: calc(100% + 6px);
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[0\\] {
  z-index: 0;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[9995\\] {
  z-index: 9995;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.order-4 {
  order: 4;
}
.order-5 {
  order: 5;
}
.order-6 {
  order: 6;
}
.order-7 {
  order: 7;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-5 {
  grid-column: span 5 / span 5;
}
.float-right {
  float: right;
}
.m-0 {
  margin: 0px;
}
.m-0\\.5 {
  margin: 0.125rem;
}
.m-1 {
  margin: 0.25rem;
}
.m-4 {
  margin: 1rem;
}
.-my-1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.-my-1\\.5 {
  margin-top: -0.375rem;
  margin-bottom: -0.375rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-\\[20px\\] {
  margin-left: 20px;
  margin-right: 20px;
}
.mx-\\[5px\\] {
  margin-left: 5px;
  margin-right: 5px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mx-px {
  margin-left: 1px;
  margin-right: 1px;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-1\\.5 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-ml-4 {
  margin-left: -1rem;
}
.-mt-6 {
  margin-top: -1.5rem;
}
.-mt-\\[34px\\] {
  margin-top: -34px;
}
.-mt-\\[5px\\] {
  margin-top: -5px;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[-4px\\] {
  margin-bottom: -4px;
}
.mb-\\[-8px\\] {
  margin-bottom: -8px;
}
.ml-0 {
  margin-left: 0px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-2\\.5 {
  margin-left: 0.625rem;
}
.ml-20 {
  margin-left: 5rem;
}
.ml-28 {
  margin-left: 7rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-8 {
  margin-left: 2rem;
}
.ml-\\[18px\\] {
  margin-left: 18px;
}
.ml-\\[5px\\] {
  margin-left: 5px;
}
.ml-auto {
  margin-left: auto;
}
.mr-0 {
  margin-right: 0px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-12 {
  margin-right: 3rem;
}
.mr-14 {
  margin-right: 3.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mr-8 {
  margin-right: 2rem;
}
.mr-\\[5px\\] {
  margin-right: 5px;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-9 {
  margin-top: 2.25rem;
}
.mt-\\[-16px\\] {
  margin-top: -16px;
}
.mt-\\[-32px\\] {
  margin-top: -32px;
}
.mt-\\[18px\\] {
  margin-top: 18px;
}
.mt-\\[22px\\] {
  margin-top: 22px;
}
.mt-\\[60px\\] {
  margin-top: 60px;
}
.mt-px {
  margin-top: 1px;
}
.box-border {
  box-sizing: border-box;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.\\!h-4 {
  height: 1rem !important;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[110px\\] {
  height: 110px;
}
.h-\\[12px\\] {
  height: 12px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[290px\\] {
  height: 290px;
}
.h-\\[29px\\] {
  height: 29px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[37px\\] {
  height: 37px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[45vh\\] {
  height: 45vh;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[52px\\] {
  height: 52px;
}
.h-\\[58px\\] {
  height: 58px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[6px\\] {
  height: 6px;
}
.h-\\[74px\\] {
  height: 74px;
}
.h-\\[75px\\] {
  height: 75px;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-\\[90px\\] {
  height: 90px;
}
.h-full {
  height: 100%;
}
.h-max {
  height: max-content;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[100vh\\] {
  max-height: 100vh;
}
.max-h-\\[32px\\] {
  max-height: 32px;
}
.max-h-\\[40px\\] {
  max-height: 40px;
}
.max-h-\\[45vh\\] {
  max-height: 45vh;
}
.max-h-\\[48px\\] {
  max-height: 48px;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[100vh\\] {
  min-height: 100vh;
}
.min-h-\\[12px\\] {
  min-height: 12px;
}
.min-h-\\[24px\\] {
  min-height: 24px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-\\[600px\\] {
  min-height: 600px;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-4 {
  width: 1rem !important;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/5 {
  width: 40%;
}
.w-20 {
  width: 5rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-3\\/5 {
  width: 60%;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[115px\\] {
  width: 115px;
}
.w-\\[12px\\] {
  width: 12px;
}
.w-\\[148px\\] {
  width: 148px;
}
.w-\\[14px\\] {
  width: 14px;
}
.w-\\[174px\\] {
  width: 174px;
}
.w-\\[184px\\] {
  width: 184px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[202px\\] {
  width: 202px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[220px\\] {
  width: 220px;
}
.w-\\[230px\\] {
  width: 230px;
}
.w-\\[245px\\] {
  width: 245px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[259px\\] {
  width: 259px;
}
.w-\\[26px\\] {
  width: 26px;
}
.w-\\[275px\\] {
  width: 275px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[35\\%\\] {
  width: 35%;
}
.w-\\[352px\\] {
  width: 352px;
}
.w-\\[360px\\] {
  width: 360px;
}
.w-\\[36px\\] {
  width: 36px;
}
.w-\\[437px\\] {
  width: 437px;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[58px\\] {
  width: 58px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[74px\\] {
  width: 74px;
}
.w-\\[75px\\] {
  width: 75px;
}
.w-\\[76px\\] {
  width: 76px;
}
.w-\\[78px\\] {
  width: 78px;
}
.w-\\[85\\%\\] {
  width: 85%;
}
.w-\\[85px\\] {
  width: 85px;
}
.w-\\[88px\\] {
  width: 88px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[100vw\\] {
  min-width: 100vw;
}
.min-w-\\[12px\\] {
  min-width: 12px;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[184px\\] {
  min-width: 184px;
}
.min-w-\\[18px\\] {
  min-width: 18px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[40\\%\\] {
  min-width: 40%;
}
.min-w-\\[420px\\] {
  min-width: 420px;
}
.min-w-\\[485px\\] {
  min-width: 485px;
}
.min-w-\\[48px\\] {
  min-width: 48px;
}
.min-w-\\[75px\\] {
  min-width: 75px;
}
.min-w-\\[80\\%\\] {
  min-width: 80%;
}
.min-w-\\[90\\%\\] {
  min-width: 90%;
}
.min-w-\\[900px\\] {
  min-width: 900px;
}
.min-w-\\[95\\%\\] {
  min-width: 95%;
}
.min-w-\\[960px\\] {
  min-width: 960px;
}
.max-w-\\[100vw\\] {
  max-width: 100vw;
}
.max-w-\\[1040px\\] {
  max-width: 1040px;
}
.max-w-\\[240px\\] {
  max-width: 240px;
}
.max-w-\\[32px\\] {
  max-width: 32px;
}
.max-w-\\[360px\\] {
  max-width: 360px;
}
.max-w-\\[40px\\] {
  max-width: 40px;
}
.max-w-\\[480px\\] {
  max-width: 480px;
}
.max-w-\\[48px\\] {
  max-width: 48px;
}
.max-w-\\[560px\\] {
  max-width: 560px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[95\\%\\] {
  max-width: 95%;
}
.max-w-\\[calc\\(100vw-32px\\)\\] {
  max-width: calc(100vw - 32px);
}
.max-w-\\[min\\(90vw\\2c 420px\\)\\] {
  max-width: min(90vw,420px);
}
.max-w-full {
  max-width: 100%;
}
.max-w-none {
  max-width: none;
}
.max-w-screen-2xl {
  max-width: 1536px;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-\\[1_1_180px\\] {
  flex: 1 1 180px;
}
.flex-\\[2\\] {
  flex: 2 1;
}
.flex-\\[3\\] {
  flex: 3 1;
}
.flex-\\[5\\] {
  flex: 5 1;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.basis-full {
  flex-basis: 100%;
}
.border-collapse {
  border-collapse: collapse;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2\\/4 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/4 {
  --tw-translate-y: -25%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2\\/4 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2\\/4 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2\\/4 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-0 {
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-100 {
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes out {

  from {
    transform: translate(20px, 0);
  }

  to {
    transform: translate(0, 0);
  }
}
.animate-\\[out_1s_ease-in-out_forwards\\] {
  animation: out 1s ease-in-out forwards;
}
@keyframes fade-in {

  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.animate-fade-in {
  animation: fade-in 160ms ease-out;
}
@keyframes indet {

  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(290%);
  }
}
.animate-indet {
  animation: indet 1.3s ease-in-out infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.select-all {
  -webkit-user-select: all;
          user-select: all;
}
.\\!resize-none {
  resize: none !important;
}
.resize-y {
  resize: vertical;
}
.\\!resize {
  resize: both !important;
}
.resize {
  resize: both;
}
.list-decimal {
  list-style-type: decimal;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.grid-rows-\\[auto_1fr_auto\\] {
  grid-template-rows: auto 1fr auto;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-3\\.5 {
  gap: 0.875rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[3px\\] {
  gap: 3px;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-2\\.5 {
  row-gap: 0.625rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-amber-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(255 179 0 / var(--tw-divide-opacity));
}
.divide-blue-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(30 136 229 / var(--tw-divide-opacity));
}
.divide-blue-gray-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-divide-opacity));
}
.divide-blue-gray-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(84 110 122 / var(--tw-divide-opacity));
}
.divide-brown-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(109 76 65 / var(--tw-divide-opacity));
}
.divide-cyan-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(0 172 193 / var(--tw-divide-opacity));
}
.divide-deep-orange-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(244 81 30 / var(--tw-divide-opacity));
}
.divide-deep-purple-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(94 53 177 / var(--tw-divide-opacity));
}
.divide-gray-800 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(66 66 66 / var(--tw-divide-opacity));
}
.divide-green-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(67 160 71 / var(--tw-divide-opacity));
}
.divide-indigo-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(57 73 171 / var(--tw-divide-opacity));
}
.divide-light-blue-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(3 155 229 / var(--tw-divide-opacity));
}
.divide-light-green-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(124 179 66 / var(--tw-divide-opacity));
}
.divide-lime-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(192 202 51 / var(--tw-divide-opacity));
}
.divide-orange-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(251 140 0 / var(--tw-divide-opacity));
}
.divide-pink-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(216 27 96 / var(--tw-divide-opacity));
}
.divide-purple-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(142 36 170 / var(--tw-divide-opacity));
}
.divide-red-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 57 53 / var(--tw-divide-opacity));
}
.divide-teal-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(0 137 123 / var(--tw-divide-opacity));
}
.divide-yellow-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(253 216 53 / var(--tw-divide-opacity));
}
.place-self-end {
  place-self: end;
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.justify-self-start {
  justify-self: start;
}
.justify-self-end {
  justify-self: end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.\\!overflow-visible {
  overflow: visible !important;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-full {
  border-radius: 9999px !important;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 15px;
}
.rounded-3xl {
  border-radius: 20px;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[15px\\] {
  border-radius: 15px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[30px\\] {
  border-radius: 30px;
}
.rounded-\\[32px\\] {
  border-radius: 32px;
}
.rounded-\\[35\\%\\] {
  border-radius: 35%;
}
.rounded-\\[3px\\] {
  border-radius: 3px;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[60px\\] {
  border-radius: 60px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-\\[9px\\] {
  border-radius: 9px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 10px;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-2xl {
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}
.rounded-b-3xl {
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}
.rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-3xl {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-t-2xl {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.rounded-t-3xl {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.\\!border-white {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#e2e2e2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(226 226 226 / var(--tw-border-opacity));
}
.border-\\[\\#f0c2c2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(240 194 194 / var(--tw-border-opacity));
}
.border-\\[\\#f0d6a8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(240 214 168 / var(--tw-border-opacity));
}
.border-accent-solid {
  --tw-border-opacity: 1;
  border-color: rgb(var(--accent-solid) / var(--tw-border-opacity));
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.border-blue-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-blue-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.border-blue-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-border-opacity));
}
.border-blue-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.border-border {
  --tw-border-opacity: 1;
  border-color: rgb(var(--border) / var(--tw-border-opacity));
}
.border-brown-500 {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.border-cyan-450 {
  --tw-border-opacity: 1;
  border-color: rgb(8 162 186 / var(--tw-border-opacity));
}
.border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.border-cyan-650 {
  --tw-border-opacity: 1;
  border-color: rgb(26 103 123 / var(--tw-border-opacity));
}
.border-cyan-75 {
  --tw-border-opacity: 1;
  border-color: rgb(147 180 191 / var(--tw-border-opacity));
}
.border-danger-border {
  --tw-border-opacity: 1;
  border-color: rgb(var(--danger-border) / var(--tw-border-opacity));
}
.border-deep-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.border-deep-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity));
}
.border-gray-150 {
  --tw-border-opacity: 1;
  border-color: rgb(221 221 221 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.border-gray-350 {
  --tw-border-opacity: 1;
  border-color: rgb(146 146 146 / var(--tw-border-opacity));
}
.border-gray-75 {
  --tw-border-opacity: 1;
  border-color: rgb(242 242 242 / var(--tw-border-opacity));
}
.border-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.border-light-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.border-light-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.border-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--success) / var(--tw-border-opacity));
}
.border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.border-tl-old {
  --tw-border-opacity: 1;
  border-color: rgb(var(--tl-old) / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-warn {
  --tw-border-opacity: 1;
  border-color: rgb(var(--warn) / var(--tw-border-opacity));
}
.border-warn-border {
  --tw-border-opacity: 1;
  border-color: rgb(var(--warn-border) / var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-white\\/80 {
  border-color: rgb(255 255 255 / 0.8);
}
.border-yellow-400 {
  --tw-border-opacity: 1;
  border-color: rgb(255 238 88 / var(--tw-border-opacity));
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.\\!border-t-transparent {
  border-top-color: transparent !important;
}
.border-b-blue-gray-100 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-l-\\[\\#f2f2f2\\] {
  --tw-border-opacity: 1;
  border-left-color: rgb(242 242 242 / var(--tw-border-opacity));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-t-blue-gray-100 {
  --tw-border-opacity: 1;
  border-top-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-t-transparent {
  border-top-color: transparent;
}
.\\!bg-danger {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--danger) / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#14171a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 23 26 / var(--tw-bg-opacity));
}
.bg-\\[\\#b8790f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(184 121 15 / var(--tw-bg-opacity));
}
.bg-\\[\\#c23b3b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(194 59 59 / var(--tw-bg-opacity));
}
.bg-\\[\\#e8f6f8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 246 248 / var(--tw-bg-opacity));
}
.bg-\\[color-mix\\(in_srgb\\2c rgb\\(var\\(--accent-solid\\)\\)_6\\%\\2c rgb\\(var\\(--surface\\)\\)\\)\\] {
  background-color: color-mix(in srgb,rgb(var(--accent-solid)) 6%,rgb(var(--surface)));
}
.bg-\\[color-mix\\(in_srgb\\2c rgb\\(var\\(--accent-solid\\)\\)_9\\%\\2c rgb\\(var\\(--surface\\)\\)\\)\\] {
  background-color: color-mix(in srgb,rgb(var(--accent-solid)) 9%,rgb(var(--surface)));
}
.bg-\\[rgb\\(var\\(--scrim\\)\\/var\\(--scrim-alpha\\)\\)\\] {
  background-color: rgb(var(--scrim)/var(--scrim-alpha));
}
.bg-accent-solid {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--accent-solid) / var(--tw-bg-opacity));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.bg-amber-500\\/10 {
  background-color: rgb(255 193 7 / 0.1);
}
.bg-amber-500\\/20 {
  background-color: rgb(255 193 7 / 0.2);
}
.bg-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg) / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-250 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 174 229 / var(--tw-bg-opacity));
}
.bg-blue-350 {
  --tw-bg-opacity: 1;
  background-color: rgb(54 174 227 / var(--tw-bg-opacity));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}
.bg-blue-500\\/10 {
  background-color: rgb(33 150 243 / 0.1);
}
.bg-blue-500\\/20 {
  background-color: rgb(33 150 243 / 0.2);
}
.bg-blue-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(62 88 149 / var(--tw-bg-opacity));
}
.bg-blue-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}
.bg-blue-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.bg-blue-gray-50\\/50 {
  background-color: rgb(236 239 241 / 0.5);
}
.bg-blue-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.bg-blue-gray-500\\/10 {
  background-color: rgb(96 125 139 / 0.1);
}
.bg-blue-gray-500\\/20 {
  background-color: rgb(96 125 139 / 0.2);
}
.bg-border {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--border) / var(--tw-bg-opacity));
}
.bg-brown-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}
.bg-brown-500\\/10 {
  background-color: rgb(121 85 72 / 0.1);
}
.bg-brown-500\\/20 {
  background-color: rgb(121 85 72 / 0.2);
}
.bg-current {
  background-color: currentColor;
}
.bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}
.bg-cyan-500\\/10 {
  background-color: rgb(0 188 212 / 0.1);
}
.bg-cyan-500\\/20 {
  background-color: rgb(0 188 212 / 0.2);
}
.bg-danger-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--danger-bg) / var(--tw-bg-opacity));
}
.bg-deep-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}
.bg-deep-orange-500\\/10 {
  background-color: rgb(255 87 34 / 0.1);
}
.bg-deep-orange-500\\/20 {
  background-color: rgb(255 87 34 / 0.2);
}
.bg-deep-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}
.bg-deep-purple-500\\/10 {
  background-color: rgb(103 58 183 / 0.1);
}
.bg-deep-purple-500\\/20 {
  background-color: rgb(103 58 183 / 0.2);
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}
.bg-gray-25 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity));
}
.bg-gray-450 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity));
}
.bg-gray-75 {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.bg-gray-900\\/10 {
  background-color: rgb(33 33 33 / 0.1);
}
.bg-green-450 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 211 137 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.bg-green-500\\/10 {
  background-color: rgb(76 175 80 / 0.1);
}
.bg-green-500\\/20 {
  background-color: rgb(76 175 80 / 0.2);
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}
.bg-indigo-500\\/10 {
  background-color: rgb(63 81 181 / 0.1);
}
.bg-indigo-500\\/20 {
  background-color: rgb(63 81 181 / 0.2);
}
.bg-light-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}
.bg-light-blue-500\\/10 {
  background-color: rgb(3 169 244 / 0.1);
}
.bg-light-blue-500\\/20 {
  background-color: rgb(3 169 244 / 0.2);
}
.bg-light-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}
.bg-light-green-500\\/10 {
  background-color: rgb(139 195 74 / 0.1);
}
.bg-light-green-500\\/20 {
  background-color: rgb(139 195 74 / 0.2);
}
.bg-lime-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}
.bg-lime-500\\/10 {
  background-color: rgb(205 220 57 / 0.1);
}
.bg-lime-500\\/20 {
  background-color: rgb(205 220 57 / 0.2);
}
.bg-muted {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--text-muted) / var(--tw-bg-opacity));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}
.bg-orange-500\\/10 {
  background-color: rgb(255 152 0 / 0.1);
}
.bg-orange-500\\/20 {
  background-color: rgb(255 152 0 / 0.2);
}
.bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}
.bg-pink-500\\/10 {
  background-color: rgb(233 30 99 / 0.1);
}
.bg-pink-500\\/20 {
  background-color: rgb(233 30 99 / 0.2);
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}
.bg-purple-500\\/10 {
  background-color: rgb(156 39 176 / 0.1);
}
.bg-purple-500\\/20 {
  background-color: rgb(156 39 176 / 0.2);
}
.bg-purple-650 {
  --tw-bg-opacity: 1;
  background-color: rgb(117 22 241 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.bg-red-500\\/10 {
  background-color: rgb(244 67 54 / 0.1);
}
.bg-red-500\\/20 {
  background-color: rgb(244 67 54 / 0.2);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 57 53 / var(--tw-bg-opacity));
}
.bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--success) / var(--tw-bg-opacity));
}
.bg-success-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--success-bg) / var(--tw-bg-opacity));
}
.bg-surface {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--surface) / var(--tw-bg-opacity));
}
.bg-surface-alt {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--surface-alt) / var(--tw-bg-opacity));
}
.bg-surface-muted {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--surface-muted) / var(--tw-bg-opacity));
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}
.bg-teal-500\\/10 {
  background-color: rgb(0 150 136 / 0.1);
}
.bg-teal-500\\/20 {
  background-color: rgb(0 150 136 / 0.2);
}
.bg-text {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--text) / var(--tw-bg-opacity));
}
.bg-text-muted {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--text-muted) / var(--tw-bg-opacity));
}
.bg-text-muted\\/\\[\\.55\\] {
  background-color: rgb(var(--text-muted) / .55);
}
.bg-tl-new {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tl-new) / var(--tw-bg-opacity));
}
.bg-tl-old {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tl-old) / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-warn {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--warn) / var(--tw-bg-opacity));
}
.bg-warn-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--warn-bg) / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 238 88 / var(--tw-bg-opacity));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}
.bg-yellow-500\\/10 {
  background-color: rgb(255 235 59 / 0.1);
}
.bg-yellow-500\\/20 {
  background-color: rgb(255 235 59 / 0.2);
}
.bg-zinc-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.\\!bg-none {
  background-image: none !important;
}
.bg-\\[image\\:repeating-linear-gradient\\(135deg\\2c rgb\\(var\\(--warn\\)\\)_0_2px\\2c transparent_2px_6px\\)\\] {
  background-image: repeating-linear-gradient(135deg,rgb(var(--warn)) 0 2px,transparent 2px 6px);
}
.bg-\\[image\\:repeating-linear-gradient\\(45deg\\2c rgb\\(var\\(--tl-old\\)\\)_0_2px\\2c transparent_2px_6px\\)\\] {
  background-image: repeating-linear-gradient(45deg,rgb(var(--tl-old)) 0 2px,transparent 2px 6px);
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[\\#D3CB03\\] {
  --tw-gradient-from: #D3CB03 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(211 203 3 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-600 {
  --tw-gradient-from: #ffb300 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 179 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600 {
  --tw-gradient-from: #1e88e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 136 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-gray-600 {
  --tw-gradient-from: #546e7a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(84 110 122 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-brown-600 {
  --tw-gradient-from: #6d4c41 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(109 76 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-600 {
  --tw-gradient-from: #00acc1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 172 193 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-650 {
  --tw-gradient-from: #1A677B var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 103 123 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-deep-orange-600 {
  --tw-gradient-from: #f4511e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 81 30 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-deep-purple-600 {
  --tw-gradient-from: #5e35b1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(94 53 177 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-250 {
  --tw-gradient-from: #ebf0f3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(235 240 243 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-600 {
  --tw-gradient-from: #757575 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(117 117 117 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900 {
  --tw-gradient-from: #212121 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(33 33 33 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600 {
  --tw-gradient-from: #43a047 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 160 71 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600 {
  --tw-gradient-from: #3949ab var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(57 73 171 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-light-blue-600 {
  --tw-gradient-from: #039be5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(3 155 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-light-green-600 {
  --tw-gradient-from: #7cb342 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 179 66 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lime-600 {
  --tw-gradient-from: #c0ca33 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 202 51 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-600 {
  --tw-gradient-from: #fb8c00 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 140 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-600 {
  --tw-gradient-from: #d81b60 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(216 27 96 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600 {
  --tw-gradient-from: #8e24aa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(142 36 170 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-600 {
  --tw-gradient-from: #e53935 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(229 57 53 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-600 {
  --tw-gradient-from: #00897b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 137 123 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-600 {
  --tw-gradient-from: #fdd835 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 216 53 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#FFD600\\] {
  --tw-gradient-to: #FFD600 var(--tw-gradient-to-position);
}
.to-amber-400 {
  --tw-gradient-to: #ffca28 var(--tw-gradient-to-position);
}
.to-blue-400 {
  --tw-gradient-to: #42a5f5 var(--tw-gradient-to-position);
}
.to-blue-gray-400 {
  --tw-gradient-to: #78909c var(--tw-gradient-to-position);
}
.to-brown-400 {
  --tw-gradient-to: #8d6e63 var(--tw-gradient-to-position);
}
.to-cyan-400 {
  --tw-gradient-to: #26c6da var(--tw-gradient-to-position);
}
.to-cyan-75 {
  --tw-gradient-to: #93B4BF var(--tw-gradient-to-position);
}
.to-deep-orange-400 {
  --tw-gradient-to: #ff7043 var(--tw-gradient-to-position);
}
.to-deep-purple-400 {
  --tw-gradient-to: #7e57c2 var(--tw-gradient-to-position);
}
.to-gray-400 {
  --tw-gradient-to: #bdbdbd var(--tw-gradient-to-position);
}
.to-gray-50 {
  --tw-gradient-to: #f7f7f7 var(--tw-gradient-to-position);
}
.to-gray-800 {
  --tw-gradient-to: #424242 var(--tw-gradient-to-position);
}
.to-green-400 {
  --tw-gradient-to: #66bb6a var(--tw-gradient-to-position);
}
.to-indigo-400 {
  --tw-gradient-to: #5c6bc0 var(--tw-gradient-to-position);
}
.to-light-blue-400 {
  --tw-gradient-to: #29b6f6 var(--tw-gradient-to-position);
}
.to-light-green-400 {
  --tw-gradient-to: #9ccc65 var(--tw-gradient-to-position);
}
.to-lime-400 {
  --tw-gradient-to: #d4e157 var(--tw-gradient-to-position);
}
.to-orange-400 {
  --tw-gradient-to: #ffa726 var(--tw-gradient-to-position);
}
.to-pink-400 {
  --tw-gradient-to: #ec407a var(--tw-gradient-to-position);
}
.to-purple-400 {
  --tw-gradient-to: #ab47bc var(--tw-gradient-to-position);
}
.to-red-400 {
  --tw-gradient-to: #ef5350 var(--tw-gradient-to-position);
}
.to-teal-400 {
  --tw-gradient-to: #26a69a var(--tw-gradient-to-position);
}
.to-yellow-400 {
  --tw-gradient-to: #ffee58 var(--tw-gradient-to-position);
}
.bg-clip-border {
  background-clip: border-box;
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.object-cover {
  object-fit: cover;
}
.object-center {
  object-position: center;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[2px\\] {
  padding: 2px;
}
.p-\\[30px\\] {
  padding: 30px;
}
.p-\\[9px\\] {
  padding: 9px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[18px\\] {
  padding-left: 18px;
  padding-right: 18px;
}
.px-\\[50px\\] {
  padding-left: 50px;
  padding-right: 50px;
}
.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}
.px-px {
  padding-left: 1px;
  padding-right: 1px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[18px\\] {
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.\\!pr-7 {
  padding-right: 1.75rem !important;
}
.\\!pr-9 {
  padding-right: 2.25rem !important;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-7 {
  padding-bottom: 1.75rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[120px\\] {
  padding-bottom: 120px;
}
.pb-\\[75px\\] {
  padding-bottom: 75px;
}
.pb-\\[90px\\] {
  padding-bottom: 90px;
}
.pb-px {
  padding-bottom: 1px;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-16 {
  padding-left: 4rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-\\[18px\\] {
  padding-left: 18px;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-3\\.5 {
  padding-top: 0.875rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-7 {
  padding-top: 1.75rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[35px\\] {
  padding-top: 35px;
}
.pt-\\[9px\\] {
  padding-top: 9px;
}
.pt-px {
  padding-top: 1px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.align-bottom {
  vertical-align: bottom;
}
.font-roboto {
  font-family: Roboto;
}
.font-sans {
  font-family: Montserrat, sans-serif, Montserrat, sans-serif;
}
.\\!text-\\[11px\\] {
  font-size: 11px !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[200\\%\\] {
  font-size: 200%;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[34px\\] {
  font-size: 34px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.\\!leading-tight {
  line-height: 1.25 !important;
}
.leading-10 {
  line-height: 2.5rem;
}
.leading-4 {
  line-height: 1rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-\\[1\\.35\\] {
  line-height: 1.35;
}
.leading-\\[1\\.3\\] {
  line-height: 1.3;
}
.leading-\\[1\\.5\\] {
  line-height: 1.5;
}
.leading-\\[14px\\] {
  line-height: 14px;
}
.leading-\\[3\\.75\\] {
  line-height: 3.75;
}
.leading-\\[4\\.1\\] {
  line-height: 4.1;
}
.leading-\\[4\\.25\\] {
  line-height: 4.25;
}
.leading-\\[4\\.875\\] {
  line-height: 4.875;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[-\\.01em\\] {
  letter-spacing: -.01em;
}
.tracking-\\[-\\.02em\\] {
  letter-spacing: -.02em;
}
.tracking-\\[-\\.03em\\] {
  letter-spacing: -.03em;
}
.tracking-\\[\\.02em\\] {
  letter-spacing: .02em;
}
.tracking-\\[\\.06em\\] {
  letter-spacing: .06em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#14171a\\] {
  --tw-text-opacity: 1;
  color: rgb(20 23 26 / var(--tw-text-opacity));
}
.text-\\[\\#8c8c8c\\] {
  --tw-text-opacity: 1;
  color: rgb(140 140 140 / var(--tw-text-opacity));
}
.text-\\[\\#93B4BF\\] {
  --tw-text-opacity: 1;
  color: rgb(147 180 191 / var(--tw-text-opacity));
}
.text-\\[\\#b8790f\\] {
  --tw-text-opacity: 1;
  color: rgb(184 121 15 / var(--tw-text-opacity));
}
.text-\\[\\#c23b3b\\] {
  --tw-text-opacity: 1;
  color: rgb(194 59 59 / var(--tw-text-opacity));
}
.text-accent-solid {
  --tw-text-opacity: 1;
  color: rgb(var(--accent-solid) / var(--tw-text-opacity));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(255 160 0 / var(--tw-text-opacity));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(255 111 0 / var(--tw-text-opacity));
}
.text-bg {
  --tw-text-opacity: 1;
  color: rgb(var(--bg) / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(25 118 210 / var(--tw-text-opacity));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(13 71 161 / var(--tw-text-opacity));
}
.text-blue-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(120 144 156 / var(--tw-text-opacity));
}
.text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.text-blue-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(69 90 100 / var(--tw-text-opacity));
}
.text-blue-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}
.text-brown-500 {
  --tw-text-opacity: 1;
  color: rgb(121 85 72 / var(--tw-text-opacity));
}
.text-brown-700 {
  --tw-text-opacity: 1;
  color: rgb(93 64 55 / var(--tw-text-opacity));
}
.text-brown-900 {
  --tw-text-opacity: 1;
  color: rgb(62 39 35 / var(--tw-text-opacity));
}
.text-current {
  color: currentColor;
}
.text-cyan-450 {
  --tw-text-opacity: 1;
  color: rgb(8 162 186 / var(--tw-text-opacity));
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(0 188 212 / var(--tw-text-opacity));
}
.text-cyan-650 {
  --tw-text-opacity: 1;
  color: rgb(26 103 123 / var(--tw-text-opacity));
}
.text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(0 151 167 / var(--tw-text-opacity));
}
.text-cyan-900 {
  --tw-text-opacity: 1;
  color: rgb(0 96 100 / var(--tw-text-opacity));
}
.text-danger {
  --tw-text-opacity: 1;
  color: rgb(var(--danger) / var(--tw-text-opacity));
}
.text-deep-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 87 34 / var(--tw-text-opacity));
}
.text-deep-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(230 74 25 / var(--tw-text-opacity));
}
.text-deep-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(191 54 12 / var(--tw-text-opacity));
}
.text-deep-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity));
}
.text-deep-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(81 45 168 / var(--tw-text-opacity));
}
.text-deep-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(49 27 146 / var(--tw-text-opacity));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(224 224 224 / var(--tw-text-opacity));
}
.text-gray-350 {
  --tw-text-opacity: 1;
  color: rgb(146 146 146 / var(--tw-text-opacity));
}
.text-gray-450 {
  --tw-text-opacity: 1;
  color: rgb(217 217 217 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(56 142 60 / var(--tw-text-opacity));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(27 94 32 / var(--tw-text-opacity));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(63 81 181 / var(--tw-text-opacity));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(48 63 159 / var(--tw-text-opacity));
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(26 35 126 / var(--tw-text-opacity));
}
.text-inherit {
  color: inherit;
}
.text-light-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}
.text-light-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(2 136 209 / var(--tw-text-opacity));
}
.text-light-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(1 87 155 / var(--tw-text-opacity));
}
.text-light-green-500 {
  --tw-text-opacity: 1;
  color: rgb(139 195 74 / var(--tw-text-opacity));
}
.text-light-green-700 {
  --tw-text-opacity: 1;
  color: rgb(104 159 56 / var(--tw-text-opacity));
}
.text-light-green-900 {
  --tw-text-opacity: 1;
  color: rgb(51 105 30 / var(--tw-text-opacity));
}
.text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(205 220 57 / var(--tw-text-opacity));
}
.text-lime-700 {
  --tw-text-opacity: 1;
  color: rgb(175 180 43 / var(--tw-text-opacity));
}
.text-lime-900 {
  --tw-text-opacity: 1;
  color: rgb(130 119 23 / var(--tw-text-opacity));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 152 0 / var(--tw-text-opacity));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(245 124 0 / var(--tw-text-opacity));
}
.text-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(230 81 0 / var(--tw-text-opacity));
}
.text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(233 30 99 / var(--tw-text-opacity));
}
.text-pink-700 {
  --tw-text-opacity: 1;
  color: rgb(194 24 91 / var(--tw-text-opacity));
}
.text-pink-900 {
  --tw-text-opacity: 1;
  color: rgb(136 14 79 / var(--tw-text-opacity));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(156 39 176 / var(--tw-text-opacity));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(123 31 162 / var(--tw-text-opacity));
}
.text-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(74 20 140 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(229 57 53 / var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(183 28 28 / var(--tw-text-opacity));
}
.text-success-ink {
  --tw-text-opacity: 1;
  color: rgb(var(--success-ink) / var(--tw-text-opacity));
}
.text-surface {
  --tw-text-opacity: 1;
  color: rgb(var(--surface) / var(--tw-text-opacity));
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(0 150 136 / var(--tw-text-opacity));
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(0 121 107 / var(--tw-text-opacity));
}
.text-teal-900 {
  --tw-text-opacity: 1;
  color: rgb(0 77 64 / var(--tw-text-opacity));
}
.text-text {
  --tw-text-opacity: 1;
  color: rgb(var(--text) / var(--tw-text-opacity));
}
.text-text-muted {
  --tw-text-opacity: 1;
  color: rgb(var(--text-muted) / var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-warn {
  --tw-text-opacity: 1;
  color: rgb(var(--warn) / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(255 238 88 / var(--tw-text-opacity));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(255 235 59 / var(--tw-text-opacity));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(251 192 45 / var(--tw-text-opacity));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(245 127 23 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.accent-gray-350 {
  accent-color: #929292;
}
.opacity-0 {
  opacity: 0;
}
.opacity-10 {
  opacity: 0.1;
}
.opacity-100 {
  opacity: 1;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-\\[0\\.45\\] {
  opacity: 0.45;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_3px_0_0_rgb\\(var\\(--accent-solid\\)\\)\\] {
  --tw-shadow: inset 3px 0 0 rgb(var(--accent-solid));
  --tw-shadow-colored: inset 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_3px_0_0_rgb\\(var\\(--border\\)\\)\\] {
  --tw-shadow: inset 3px 0 0 rgb(var(--border));
  --tw-shadow-colored: inset 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_3px_0_0_rgb\\(var\\(--warn\\)\\)\\] {
  --tw-shadow: inset 3px 0 0 rgb(var(--warn));
  --tw-shadow-colored: inset 3px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card {
  --tw-shadow: var(--shadow-card);
  --tw-shadow-colored: var(--shadow-card);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-pop {
  --tw-shadow: var(--shadow-pop);
  --tw-shadow-colored: var(--shadow-pop);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-amber-500\\/20 {
  --tw-shadow-color: rgb(255 193 7 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-500\\/40 {
  --tw-shadow-color: rgb(255 193 7 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/20 {
  --tw-shadow-color: rgb(33 150 243 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/40 {
  --tw-shadow-color: rgb(33 150 243 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/10 {
  --tw-shadow-color: rgb(96 125 139 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/20 {
  --tw-shadow-color: rgb(96 125 139 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/40 {
  --tw-shadow-color: rgb(96 125 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-900\\/10 {
  --tw-shadow-color: rgb(38 50 56 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-brown-500\\/20 {
  --tw-shadow-color: rgb(121 85 72 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-brown-500\\/40 {
  --tw-shadow-color: rgb(121 85 72 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/20 {
  --tw-shadow-color: rgb(0 188 212 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/40 {
  --tw-shadow-color: rgb(0 188 212 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-orange-500\\/20 {
  --tw-shadow-color: rgb(255 87 34 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-orange-500\\/40 {
  --tw-shadow-color: rgb(255 87 34 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-purple-500\\/20 {
  --tw-shadow-color: rgb(103 58 183 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-purple-500\\/40 {
  --tw-shadow-color: rgb(103 58 183 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-900\\/10 {
  --tw-shadow-color: rgb(33 33 33 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-900\\/20 {
  --tw-shadow-color: rgb(33 33 33 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/20 {
  --tw-shadow-color: rgb(76 175 80 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/40 {
  --tw-shadow-color: rgb(76 175 80 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/20 {
  --tw-shadow-color: rgb(63 81 181 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/40 {
  --tw-shadow-color: rgb(63 81 181 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-blue-500\\/20 {
  --tw-shadow-color: rgb(3 169 244 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-blue-500\\/40 {
  --tw-shadow-color: rgb(3 169 244 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-green-500\\/20 {
  --tw-shadow-color: rgb(139 195 74 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-green-500\\/40 {
  --tw-shadow-color: rgb(139 195 74 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-lime-500\\/20 {
  --tw-shadow-color: rgb(205 220 57 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-lime-500\\/40 {
  --tw-shadow-color: rgb(205 220 57 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/20 {
  --tw-shadow-color: rgb(255 152 0 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/40 {
  --tw-shadow-color: rgb(255 152 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/20 {
  --tw-shadow-color: rgb(233 30 99 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/40 {
  --tw-shadow-color: rgb(233 30 99 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/20 {
  --tw-shadow-color: rgb(156 39 176 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/40 {
  --tw-shadow-color: rgb(156 39 176 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/20 {
  --tw-shadow-color: rgb(244 67 54 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/40 {
  --tw-shadow-color: rgb(244 67 54 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/20 {
  --tw-shadow-color: rgb(0 150 136 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/40 {
  --tw-shadow-color: rgb(0 150 136 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-yellow-500\\/20 {
  --tw-shadow-color: rgb(255 235 59 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-yellow-500\\/40 {
  --tw-shadow-color: rgb(255 235 59 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-0 {
  outline-width: 0px;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-surface {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--surface) / var(--tw-ring-opacity));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[7px\\] {
  --tw-blur: blur(7px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-2xl {
  --tw-backdrop-blur: blur(40px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-200 {
  --tw-backdrop-saturate: saturate(2);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.content-\\[\\'\\'\\] {
  --tw-content: '';
  content: var(--tw-content);
}
.\\[-webkit-appearance\\:none\\] {
  -webkit-appearance: none;
}
.\\[contain\\:inline-size\\] {
  contain: inline-size;
}

/* broker-report-sync: semantic colour roles of the design mock (docs/design-system.md), RGB triplets so Tailwind opacity modifiers work. */
:root {
  --bg: 250 250 250;
  --surface: 255 255 255;
  --surface-alt: 242 242 242;
  --surface-muted: 247 247 247;
  --border: 226 226 226;
  --text: 20 23 26;
  --text-muted: 140 140 140;
  --accent-solid: 8 162 186;
  --accent-solid-hover: 10 142 163;
  --success: 3 211 137;
  --success-ink: 4 106 72;
  --success-bg: 228 250 241;
  --warn: 184 121 15;
  --warn-bg: 253 241 222;
  --warn-border: 240 214 168;
  --danger: 194 59 59;
  --danger-bg: 251 234 234;
  --danger-border: 240 194 194;
  --tl-new: 10 142 163;
  --tl-old: 122 111 208;
  --shadow-card: 0 1px 2px rgba(20, 23, 26, 0.04), 0 8px 24px -12px rgba(20, 23, 26, 0.12);
  --shadow-pop: 0 2px 6px rgba(20, 23, 26, 0.06), 0 24px 48px -16px rgba(20, 23, 26, 0.28);
  --scrim: 20 23 26;
  --scrim-alpha: 0.28;
}

/* Dark values apply only with an explicit data-theme="dark" on <html>: light is the default until the cabinet has a theme switch. */
:root[data-theme="dark"] {
  --bg: 20 24 26;
  --surface: 27 33 36;
  --surface-alt: 34 42 45;
  --surface-muted: 30 36 39;
  --border: 50 60 64;
  --text: 238 241 242;
  --text-muted: 147 160 164;
  --accent-solid: 47 195 222;
  --accent-solid-hover: 84 207 230;
  --success: 31 227 156;
  --success-ink: 143 243 206;
  --success-bg: 15 46 38;
  --warn: 240 179 62;
  --warn-bg: 51 37 8;
  --warn-border: 90 63 15;
  --danger: 240 113 107;
  --danger-bg: 51 19 19;
  --danger-border: 90 31 31;
  --tl-new: 24 152 176;
  --tl-old: 143 128 232;
  --shadow-card: 0 1px 2px rgba(0, 0, 0, 0.3), 0 8px 24px -12px rgba(0, 0, 0, 0.5);
  --shadow-pop: 0 2px 6px rgba(0, 0, 0, 0.35), 0 24px 48px -16px rgba(0, 0, 0, 0.7);
  --scrim: 0 0 0;
  --scrim-alpha: 0.45;
}

.page {
    @media screen and (max-width: 1279px) {
        padding: 60px 30px;
    }
    @media screen and (max-width: 639px) {
        padding: 20px 5px;
    }
    @media screen and (min-width: 1280px) {
        padding: 90px 30px 30px 77px;
    }
}

@media (max-width: 480px) {

  html, body, #root {
    overflow: hidden;
  }
}

/* html {
    height: -webkit-fill-available;
}

body {
    min-height: 100vh;
    min-height: -webkit-fill-available;
} */

* {
    -webkit-tap-highlight-color: transparent !important;
}

.rotate {
    animation: rotate 2s linear infinite; 
}

@keyframes rotate {
    100% {
        transform: rotate(360deg); 
    }
}
/* tax-planner numbers (mock \`.num\`, \`table.pos td.num\`): digits of one width, and a number in a table cell never wraps. */
.num {
  font-variant-numeric: tabular-nums;
}
td.num, td .num {
  white-space: nowrap;
}

/* SCR-06 panel of broker-report-sync opens with a fade-in. */
.fade-in {
    animation: fade-in 150ms ease-out;
}

@keyframes fade-in {
    from {
        opacity: 0;
    }
}

/* ReportTimeline hints (mock \`.tl-bar[data-tip]\`): a dark tooltip above a bar, a coverage segment or a gap. */
[data-tip]:hover {
    z-index: 5;
}

[data-tip]:hover::after {
    content: attr(data-tip);
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    width: max-content;
    max-width: 240px;
    white-space: normal;
    background: rgb(var(--text));
    color: rgb(var(--bg));
    font-size: 11px;
    font-weight: 600;
    padding: 5px 8px;
    border-radius: 8px;
    pointer-events: none;
}

.marker\\:text-xs *::marker {
  font-size: 0.75rem;
  line-height: 1rem;
}

.marker\\:text-text-muted *::marker {
  color: rgb(var(--text-muted) );
}

.marker\\:text-xs::marker {
  font-size: 0.75rem;
  line-height: 1rem;
}

.marker\\:text-text-muted::marker {
  color: rgb(var(--text-muted) );
}

.placeholder\\:opacity-0::placeholder {
  opacity: 0;
}

.before\\:pointer-events-none::before {
  content: var(--tw-content);
  pointer-events: none;
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:-left-5::before {
  content: var(--tw-content);
  left: -1.25rem;
}

.before\\:-right-5::before {
  content: var(--tw-content);
  right: -1.25rem;
}

.before\\:bottom-auto::before {
  content: var(--tw-content);
  bottom: auto;
}

.before\\:left-2\\/4::before {
  content: var(--tw-content);
  left: 50%;
}

.before\\:top-2\\/4::before {
  content: var(--tw-content);
  top: 50%;
}

.before\\:mr-1::before {
  content: var(--tw-content);
  margin-right: 0.25rem;
}

.before\\:mt-\\[6\\.5px\\]::before {
  content: var(--tw-content);
  margin-top: 6.5px;
}

.before\\:box-border::before {
  content: var(--tw-content);
  box-sizing: border-box;
}

.before\\:block::before {
  content: var(--tw-content);
  display: block;
}

.before\\:h-1::before {
  content: var(--tw-content);
  height: 0.25rem;
}

.before\\:h-1\\.5::before {
  content: var(--tw-content);
  height: 0.375rem;
}

.before\\:h-10::before {
  content: var(--tw-content);
  height: 2.5rem;
}

.before\\:h-12::before {
  content: var(--tw-content);
  height: 3rem;
}

.before\\:h-5::before {
  content: var(--tw-content);
  height: 1.25rem;
}

.before\\:w-10::before {
  content: var(--tw-content);
  width: 2.5rem;
}

.before\\:w-12::before {
  content: var(--tw-content);
  width: 3rem;
}

.before\\:w-2::before {
  content: var(--tw-content);
  width: 0.5rem;
}

.before\\:w-2\\.5::before {
  content: var(--tw-content);
  width: 0.625rem;
}

.before\\:w-5::before {
  content: var(--tw-content);
  width: 1.25rem;
}

.before\\:-translate-x-2\\/4::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:-translate-y-2\\/4::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:rounded-tl-md::before {
  content: var(--tw-content);
  border-top-left-radius: 0.375rem;
}

.before\\:border-l::before {
  content: var(--tw-content);
  border-left-width: 1px;
}

.before\\:border-l-2::before {
  content: var(--tw-content);
  border-left-width: 2px;
}

.before\\:border-t::before {
  content: var(--tw-content);
  border-top-width: 1px;
}

.before\\:border-t-2::before {
  content: var(--tw-content);
  border-top-width: 2px;
}

.before\\:\\!border-blue-gray-200::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(176 190 197 / var(--tw-border-opacity)) !important;
}

.before\\:border-amber-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.before\\:border-black::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.before\\:border-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.before\\:border-blue-gray-200::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.before\\:border-blue-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.before\\:border-brown-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.before\\:border-cyan-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.before\\:border-deep-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.before\\:border-deep-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.before\\:border-gray-900::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.before\\:border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.before\\:border-indigo-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.before\\:border-light-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.before\\:border-light-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.before\\:border-lime-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.before\\:border-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.before\\:border-pink-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.before\\:border-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.before\\:border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.before\\:border-teal-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}

.before\\:border-white::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.before\\:border-yellow-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.before\\:border-l-transparent::before {
  content: var(--tw-content);
  border-left-color: transparent;
}

.before\\:border-t-transparent::before {
  content: var(--tw-content);
  border-top-color: transparent;
}

.before\\:bg-blue-gray-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.before\\:bg-white::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.before\\:opacity-0::before {
  content: var(--tw-content);
  opacity: 0;
}

.before\\:transition-all::before {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:transition-opacity::before {
  content: var(--tw-content);
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}

.after\\:pointer-events-none::after {
  content: var(--tw-content);
  pointer-events: none;
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:-bottom-0::after {
  content: var(--tw-content);
  bottom: -0px;
}

.after\\:-bottom-1::after {
  content: var(--tw-content);
  bottom: -0.25rem;
}

.after\\:-bottom-1\\.5::after {
  content: var(--tw-content);
  bottom: -0.375rem;
}

.after\\:-bottom-2::after {
  content: var(--tw-content);
  bottom: -0.5rem;
}

.after\\:-bottom-2\\.5::after {
  content: var(--tw-content);
  bottom: -0.625rem;
}

.after\\:-left-5::after {
  content: var(--tw-content);
  left: -1.25rem;
}

.after\\:-right-5::after {
  content: var(--tw-content);
  right: -1.25rem;
}

.after\\:bottom-0::after {
  content: var(--tw-content);
  bottom: 0px;
}

.after\\:left-0::after {
  content: var(--tw-content);
  left: 0px;
}

.after\\:top-auto::after {
  content: var(--tw-content);
  top: auto;
}

.after\\:ml-1::after {
  content: var(--tw-content);
  margin-left: 0.25rem;
}

.after\\:mt-\\[6\\.5px\\]::after {
  content: var(--tw-content);
  margin-top: 6.5px;
}

.after\\:box-border::after {
  content: var(--tw-content);
  box-sizing: border-box;
}

.after\\:block::after {
  content: var(--tw-content);
  display: block;
}

.after\\:h-1::after {
  content: var(--tw-content);
  height: 0.25rem;
}

.after\\:h-1\\.5::after {
  content: var(--tw-content);
  height: 0.375rem;
}

.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}

.after\\:h-\\[3px\\]::after {
  content: var(--tw-content);
  height: 3px;
}

.after\\:w-2::after {
  content: var(--tw-content);
  width: 0.5rem;
}

.after\\:w-2\\.5::after {
  content: var(--tw-content);
  width: 0.625rem;
}

.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}

.after\\:w-\\[40px\\]::after {
  content: var(--tw-content);
  width: 40px;
}

.after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}

.after\\:flex-grow::after {
  content: var(--tw-content);
  flex-grow: 1;
}

.after\\:scale-x-0::after {
  content: var(--tw-content);
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:scale-x-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:rounded-tl-3xl::after {
  content: var(--tw-content);
  border-top-left-radius: 20px;
}

.after\\:rounded-tr-3xl::after {
  content: var(--tw-content);
  border-top-right-radius: 20px;
}

.after\\:rounded-tr-md::after {
  content: var(--tw-content);
  border-top-right-radius: 0.375rem;
}

.after\\:border-b-2::after {
  content: var(--tw-content);
  border-bottom-width: 2px;
}

.after\\:border-r::after {
  content: var(--tw-content);
  border-right-width: 1px;
}

.after\\:border-r-2::after {
  content: var(--tw-content);
  border-right-width: 2px;
}

.after\\:border-t::after {
  content: var(--tw-content);
  border-top-width: 1px;
}

.after\\:border-t-2::after {
  content: var(--tw-content);
  border-top-width: 2px;
}

.after\\:\\!border-blue-gray-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(176 190 197 / var(--tw-border-opacity)) !important;
}

.after\\:border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.after\\:border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.after\\:border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.after\\:border-blue-gray-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.after\\:border-blue-gray-50::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-border-opacity));
}

.after\\:border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.after\\:border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.after\\:border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.after\\:border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.after\\:border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.after\\:border-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}

.after\\:border-gray-900::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.after\\:border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.after\\:border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.after\\:border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.after\\:border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.after\\:border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.after\\:border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.after\\:border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.after\\:border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.after\\:border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.after\\:border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}

.after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.after\\:border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.after\\:border-r-transparent::after {
  content: var(--tw-content);
  border-right-color: transparent;
}

.after\\:border-t-transparent::after {
  content: var(--tw-content);
  border-top-color: transparent;
}

.after\\:bg-gray-25::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}

.after\\:bg-gradient-to-r::after {
  content: var(--tw-content);
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.after\\:from-cyan-650::after {
  content: var(--tw-content);
  --tw-gradient-from: #1A677B var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 103 123 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.after\\:to-cyan-75::after {
  content: var(--tw-content);
  --tw-gradient-to: #93B4BF var(--tw-gradient-to-position);
}

.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:transition-transform::after {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:duration-300::after {
  content: var(--tw-content);
  transition-duration: 300ms;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

.checked\\:rounded:checked {
  border-radius: 0.25rem;
}

.checked\\:border-amber-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.checked\\:border-blue-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.checked\\:border-blue-gray-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.checked\\:border-brown-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.checked\\:border-cyan-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.checked\\:border-cyan-650:checked {
  --tw-border-opacity: 1;
  border-color: rgb(26 103 123 / var(--tw-border-opacity));
}

.checked\\:border-deep-orange-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.checked\\:border-deep-purple-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.checked\\:border-gray-900:checked {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.checked\\:border-green-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.checked\\:border-indigo-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.checked\\:border-light-blue-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.checked\\:border-light-green-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.checked\\:border-lime-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.checked\\:border-orange-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.checked\\:border-pink-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.checked\\:border-purple-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.checked\\:border-red-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.checked\\:border-teal-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.checked\\:border-white:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.checked\\:border-yellow-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.checked\\:bg-amber-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}

.checked\\:bg-blue-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}

.checked\\:bg-blue-gray-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.checked\\:bg-brown-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}

.checked\\:bg-cyan-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}

.checked\\:bg-deep-orange-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}

.checked\\:bg-deep-purple-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}

.checked\\:bg-gray-900:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}

.checked\\:bg-green-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}

.checked\\:bg-indigo-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}

.checked\\:bg-light-blue-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}

.checked\\:bg-light-green-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}

.checked\\:bg-lime-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}

.checked\\:bg-orange-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}

.checked\\:bg-pink-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}

.checked\\:bg-purple-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}

.checked\\:bg-red-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}

.checked\\:bg-teal-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}

.checked\\:bg-yellow-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-amber-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-blue-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-blue-gray-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-brown-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-cyan-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-deep-orange-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-deep-purple-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-gray-900:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-green-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-indigo-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-light-blue-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-light-green-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-lime-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-orange-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-pink-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-purple-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-red-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-teal-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-yellow-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}

.placeholder-shown\\:border:placeholder-shown {
  border-width: 1px;
}

.placeholder-shown\\:border-blue-gray-200:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-green-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-red-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-t-blue-gray-200:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-t-green-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-t-red-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:cursor-pointer:hover {
  cursor: pointer;
}

.hover\\:rounded-2xl:hover {
  border-radius: 15px;
}

.hover\\:rounded-bl-none:hover {
  border-bottom-left-radius: 0px;
}

.hover\\:rounded-tl-none:hover {
  border-top-left-radius: 0px;
}

.hover\\:border:hover {
  border-width: 1px;
}

.hover\\:border-white:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.hover\\:bg-amber-500\\/10:hover {
  background-color: rgb(255 193 7 / 0.1);
}

.hover\\:bg-blue-500\\/10:hover {
  background-color: rgb(33 150 243 / 0.1);
}

.hover\\:bg-blue-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-gray-500\\/10:hover {
  background-color: rgb(96 125 139 / 0.1);
}

.hover\\:bg-border:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--border) / var(--tw-bg-opacity));
}

.hover\\:bg-brown-500\\/10:hover {
  background-color: rgb(121 85 72 / 0.1);
}

.hover\\:bg-cyan-500\\/10:hover {
  background-color: rgb(0 188 212 / 0.1);
}

.hover\\:bg-cyan-650:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 103 123 / var(--tw-bg-opacity));
}

.hover\\:bg-deep-orange-500\\/10:hover {
  background-color: rgb(255 87 34 / 0.1);
}

.hover\\:bg-deep-purple-500\\/10:hover {
  background-color: rgb(103 58 183 / 0.1);
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-75:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-900\\/10:hover {
  background-color: rgb(33 33 33 / 0.1);
}

.hover\\:bg-green-500\\/10:hover {
  background-color: rgb(76 175 80 / 0.1);
}

.hover\\:bg-indigo-500\\/10:hover {
  background-color: rgb(63 81 181 / 0.1);
}

.hover\\:bg-light-blue-500\\/10:hover {
  background-color: rgb(3 169 244 / 0.1);
}

.hover\\:bg-light-green-500\\/10:hover {
  background-color: rgb(139 195 74 / 0.1);
}

.hover\\:bg-lime-500\\/10:hover {
  background-color: rgb(205 220 57 / 0.1);
}

.hover\\:bg-orange-500\\/10:hover {
  background-color: rgb(255 152 0 / 0.1);
}

.hover\\:bg-pink-500\\/10:hover {
  background-color: rgb(233 30 99 / 0.1);
}

.hover\\:bg-purple-500\\/10:hover {
  background-color: rgb(156 39 176 / 0.1);
}

.hover\\:bg-red-500\\/10:hover {
  background-color: rgb(244 67 54 / 0.1);
}

.hover\\:bg-surface-alt:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--surface-alt) / var(--tw-bg-opacity));
}

.hover\\:bg-surface-muted:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--surface-muted) / var(--tw-bg-opacity));
}

.hover\\:bg-teal-500\\/10:hover {
  background-color: rgb(0 150 136 / 0.1);
}

.hover\\:bg-transparent:hover {
  background-color: transparent;
}

.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-yellow-500\\/10:hover {
  background-color: rgb(255 235 59 / 0.1);
}

.hover\\:bg-opacity-80:hover {
  --tw-bg-opacity: 0.8;
}

.hover\\:bg-gradient-to-r:hover {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.hover\\:from-cyan-900:hover {
  --tw-gradient-from: #006064 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 96 100 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-cyan-650:hover {
  --tw-gradient-to: #1A677B var(--tw-gradient-to-position);
}

.hover\\:text-\\[\\#0a8ea3\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(10 142 163 / var(--tw-text-opacity));
}

.hover\\:text-\\[\\#14171a\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(20 23 26 / var(--tw-text-opacity));
}

.hover\\:text-blue-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.hover\\:text-blue-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}

.hover\\:text-gray-350:hover {
  --tw-text-opacity: 1;
  color: rgb(146 146 146 / var(--tw-text-opacity));
}

.hover\\:text-light-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}

.hover\\:text-text:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--text) / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:no-underline:hover {
  text-decoration-line: none;
}

.hover\\:underline-offset-2:hover {
  text-underline-offset: 2px;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-75:hover {
  opacity: 0.75;
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-amber-500\\/40:hover {
  --tw-shadow-color: rgb(255 193 7 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-500\\/40:hover {
  --tw-shadow-color: rgb(33 150 243 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-gray-500\\/20:hover {
  --tw-shadow-color: rgb(96 125 139 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-gray-500\\/40:hover {
  --tw-shadow-color: rgb(96 125 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-brown-500\\/40:hover {
  --tw-shadow-color: rgb(121 85 72 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-cyan-500\\/40:hover {
  --tw-shadow-color: rgb(0 188 212 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-deep-orange-500\\/40:hover {
  --tw-shadow-color: rgb(255 87 34 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-deep-purple-500\\/40:hover {
  --tw-shadow-color: rgb(103 58 183 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-gray-900\\/20:hover {
  --tw-shadow-color: rgb(33 33 33 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-green-500\\/40:hover {
  --tw-shadow-color: rgb(76 175 80 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-indigo-500\\/40:hover {
  --tw-shadow-color: rgb(63 81 181 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-light-blue-500\\/40:hover {
  --tw-shadow-color: rgb(3 169 244 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-light-green-500\\/40:hover {
  --tw-shadow-color: rgb(139 195 74 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-lime-500\\/40:hover {
  --tw-shadow-color: rgb(205 220 57 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-orange-500\\/40:hover {
  --tw-shadow-color: rgb(255 152 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-pink-500\\/40:hover {
  --tw-shadow-color: rgb(233 30 99 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-purple-500\\/40:hover {
  --tw-shadow-color: rgb(156 39 176 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-red-500\\/40:hover {
  --tw-shadow-color: rgb(244 67 54 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-teal-500\\/40:hover {
  --tw-shadow-color: rgb(0 150 136 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-yellow-500\\/40:hover {
  --tw-shadow-color: rgb(255 235 59 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:\\!brightness-90:hover {
  --tw-brightness: brightness(.9) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}

.hover\\:brightness-110:hover {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:before\\:opacity-0:hover::before {
  content: var(--tw-content);
  opacity: 0;
}

.hover\\:before\\:opacity-10:hover::before {
  content: var(--tw-content);
  opacity: 0.1;
}

.hover\\:after\\:absolute:hover::after {
  content: var(--tw-content);
  position: absolute;
}

.hover\\:after\\:left-0:hover::after {
  content: var(--tw-content);
  left: 0px;
}

.hover\\:after\\:top-0:hover::after {
  content: var(--tw-content);
  top: 0px;
}

.hover\\:after\\:h-9:hover::after {
  content: var(--tw-content);
  height: 2.25rem;
}

.hover\\:after\\:w-\\[3px\\]:hover::after {
  content: var(--tw-content);
  width: 3px;
}

.hover\\:after\\:rounded-r-3xl:hover::after {
  content: var(--tw-content);
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

.hover\\:after\\:bg-gradient-to-r:hover::after {
  content: var(--tw-content);
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.hover\\:after\\:from-cyan-650:hover::after {
  content: var(--tw-content);
  --tw-gradient-from: #1A677B var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 103 123 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:after\\:to-cyan-75:hover::after {
  content: var(--tw-content);
  --tw-gradient-to: #93B4BF var(--tw-gradient-to-position);
}

.hover\\:after\\:py-3:hover::after {
  content: var(--tw-content);
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.hover\\:after\\:content-\\[\\'\\'\\]:hover::after {
  --tw-content: '';
  content: var(--tw-content);
}

.focus\\:scale-110:focus {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.focus\\:border-2:focus {
  border-width: 2px;
}

.focus\\:border-amber-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.focus\\:border-black:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.focus\\:border-blue-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.focus\\:border-blue-gray-900:focus {
  --tw-border-opacity: 1;
  border-color: rgb(38 50 56 / var(--tw-border-opacity));
}

.focus\\:border-brown-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.focus\\:border-cyan-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.focus\\:border-cyan-650:focus {
  --tw-border-opacity: 1;
  border-color: rgb(26 103 123 / var(--tw-border-opacity));
}

.focus\\:border-deep-orange-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.focus\\:border-deep-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.focus\\:border-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}

.focus\\:border-gray-900:focus {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.focus\\:border-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.focus\\:border-light-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.focus\\:border-light-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.focus\\:border-lime-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.focus\\:border-orange-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.focus\\:border-pink-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.focus\\:border-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.focus\\:border-red-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.focus\\:border-teal-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.focus\\:border-white:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.focus\\:border-yellow-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.focus\\:border-t-transparent:focus {
  border-top-color: transparent;
}

.focus\\:bg-blue-gray-50:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.focus\\:bg-transparent:focus {
  background-color: transparent;
}

.focus\\:bg-opacity-80:focus {
  --tw-bg-opacity: 0.8;
}

.focus\\:text-blue-gray-500:focus {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.focus\\:text-blue-gray-900:focus {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}

.focus\\:opacity-\\[0\\.85\\]:focus {
  opacity: 0.85;
}

.focus\\:shadow-none:focus {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline-0:focus {
  outline-width: 0px;
}

.focus\\:ring:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-amber-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 224 130 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(144 202 249 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-gray-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(176 190 197 / var(--tw-ring-opacity));
}

.focus\\:ring-brown-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(188 170 164 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(128 222 234 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-450:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(8 162 186 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-650:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(26 103 123 / var(--tw-ring-opacity));
}

.focus\\:ring-deep-orange-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 171 145 / var(--tw-ring-opacity));
}

.focus\\:ring-deep-purple-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(179 157 219 / var(--tw-ring-opacity));
}

.focus\\:ring-gray-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 224 224 / var(--tw-ring-opacity));
}

.focus\\:ring-green-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 214 167 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(159 168 218 / var(--tw-ring-opacity));
}

.focus\\:ring-light-blue-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 212 250 / var(--tw-ring-opacity));
}

.focus\\:ring-light-green-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(197 225 165 / var(--tw-ring-opacity));
}

.focus\\:ring-lime-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(230 238 156 / var(--tw-ring-opacity));
}

.focus\\:ring-orange-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 204 128 / var(--tw-ring-opacity));
}

.focus\\:ring-pink-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 143 177 / var(--tw-ring-opacity));
}

.focus\\:ring-purple-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(206 147 216 / var(--tw-ring-opacity));
}

.focus\\:ring-red-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 154 154 / var(--tw-ring-opacity));
}

.focus\\:ring-teal-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(128 203 196 / var(--tw-ring-opacity));
}

.focus\\:ring-white\\/50:focus {
  --tw-ring-color: rgb(255 255 255 / 0.5);
}

.focus\\:ring-yellow-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 245 157 / var(--tw-ring-opacity));
}

.focus\\:placeholder\\:opacity-100:focus::placeholder {
  opacity: 1;
}

.focus-visible\\:outline-cyan-450:focus-visible {
  outline-color: #08a2ba;
}

.active\\:scale-100:active {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:bg-amber-500\\/30:active {
  background-color: rgb(255 193 7 / 0.3);
}

.active\\:bg-blue-500\\/30:active {
  background-color: rgb(33 150 243 / 0.3);
}

.active\\:bg-blue-gray-50:active {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.active\\:bg-blue-gray-500\\/30:active {
  background-color: rgb(96 125 139 / 0.3);
}

.active\\:bg-brown-500\\/30:active {
  background-color: rgb(121 85 72 / 0.3);
}

.active\\:bg-cyan-500\\/30:active {
  background-color: rgb(0 188 212 / 0.3);
}

.active\\:bg-deep-orange-500\\/30:active {
  background-color: rgb(255 87 34 / 0.3);
}

.active\\:bg-deep-purple-500\\/30:active {
  background-color: rgb(103 58 183 / 0.3);
}

.active\\:bg-gray-900\\/20:active {
  background-color: rgb(33 33 33 / 0.2);
}

.active\\:bg-green-500\\/30:active {
  background-color: rgb(76 175 80 / 0.3);
}

.active\\:bg-indigo-500\\/30:active {
  background-color: rgb(63 81 181 / 0.3);
}

.active\\:bg-light-blue-500\\/30:active {
  background-color: rgb(3 169 244 / 0.3);
}

.active\\:bg-light-green-500\\/30:active {
  background-color: rgb(139 195 74 / 0.3);
}

.active\\:bg-lime-500\\/30:active {
  background-color: rgb(205 220 57 / 0.3);
}

.active\\:bg-orange-500\\/30:active {
  background-color: rgb(255 152 0 / 0.3);
}

.active\\:bg-pink-500\\/30:active {
  background-color: rgb(233 30 99 / 0.3);
}

.active\\:bg-purple-500\\/30:active {
  background-color: rgb(156 39 176 / 0.3);
}

.active\\:bg-red-500\\/30:active {
  background-color: rgb(244 67 54 / 0.3);
}

.active\\:bg-teal-500\\/30:active {
  background-color: rgb(0 150 136 / 0.3);
}

.active\\:bg-transparent:active {
  background-color: transparent;
}

.active\\:bg-white\\/30:active {
  background-color: rgb(255 255 255 / 0.3);
}

.active\\:bg-yellow-500\\/30:active {
  background-color: rgb(255 235 59 / 0.3);
}

.active\\:bg-opacity-80:active {
  --tw-bg-opacity: 0.8;
}

.active\\:text-blue-gray-500:active {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.active\\:text-blue-gray-900:active {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}

.active\\:opacity-\\[0\\.85\\]:active {
  opacity: 0.85;
}

.active\\:shadow-none:active {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.active\\:brightness-95:active {
  --tw-brightness: brightness(.95);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:resize-none:disabled {
  resize: none;
}

.disabled\\:border-0:disabled {
  border-width: 0px;
}

.disabled\\:bg-blue-gray-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.disabled\\:hover\\:bg-surface:hover:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--surface) / var(--tw-bg-opacity));
}

.disabled\\:hover\\:brightness-100:hover:disabled {
  --tw-brightness: brightness(1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

@keyframes in {

  from {
    transform: translate(0, 0);
  }

  to {
    transform: translate(20px, 0);
  }
}

.group:hover .group-hover\\:animate-\\[in_1s_ease-in-out_forwards\\] {
  animation: in 1s ease-in-out forwards;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group.is-active .group-\\[\\.is-active\\]\\:block {
  display: block;
}

.peer:checked ~ .peer-checked\\:translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-blue-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-brown-500 {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-deep-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-deep-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-light-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-light-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:opacity-100 {
  opacity: 1;
}

.peer:checked ~ .peer-checked\\:before\\:bg-amber-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-blue-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-blue-gray-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-brown-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-cyan-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-deep-orange-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-deep-purple-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-gray-900::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-green-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-indigo-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-light-blue-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-light-green-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-lime-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-orange-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-pink-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-purple-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-red-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-teal-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-yellow-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[3\\.75\\] {
  line-height: 3.75;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.1\\] {
  line-height: 4.1;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.25\\] {
  line-height: 4.25;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.875\\] {
  line-height: 4.875;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-tight {
  line-height: 1.25;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:focus ~ .peer-focus\\:text-\\[11px\\] {
  font-size: 11px;
}

.peer:focus ~ .peer-focus\\:text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.peer:focus ~ .peer-focus\\:leading-tight {
  line-height: 1.25;
}

.peer:focus ~ .peer-focus\\:text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-brown-500 {
  --tw-text-opacity: 1;
  color: rgb(121 85 72 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(0 188 212 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-deep-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 87 34 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-deep-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(63 81 181 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-light-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-light-green-500 {
  --tw-text-opacity: 1;
  color: rgb(139 195 74 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(205 220 57 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 152 0 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(233 30 99 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(156 39 176 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(0 150 136 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(255 235 59 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:before\\:border-l-2::before {
  content: var(--tw-content);
  border-left-width: 2px;
}

.peer:focus ~ .peer-focus\\:before\\:border-t-2::before {
  content: var(--tw-content);
  border-top-width: 2px;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-amber-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 193 7 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-black::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 150 243 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-blue-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 125 139 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-brown-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 85 72 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-cyan-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 188 212 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-deep-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 34 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-deep-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(103 58 183 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-gray-900::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 33 33 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(76 175 80 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-indigo-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(63 81 181 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-light-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 169 244 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-light-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(139 195 74 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-lime-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(205 220 57 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 152 0 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-pink-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 30 99 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(156 39 176 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 67 54 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-teal-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 150 136 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-white::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-yellow-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 235 59 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:before\\:border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:scale-x-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:after\\:border-r-2::after {
  content: var(--tw-content);
  border-right-width: 2px;
}

.peer:focus ~ .peer-focus\\:after\\:border-t-2::after {
  content: var(--tw-content);
  border-top-width: 2px;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 193 7 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 150 243 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 125 139 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 85 72 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 188 212 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 34 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(103 58 183 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-gray-900::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 33 33 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(76 175 80 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(63 81 181 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 169 244 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(139 195 74 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(205 220 57 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 152 0 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 30 99 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(156 39 176 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 67 54 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 150 136 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 235 59 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-gray-900::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.peer:disabled ~ .peer-disabled\\:text-blue-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(120 144 156 / var(--tw-text-opacity));
}

.peer:disabled ~ .peer-disabled\\:text-transparent {
  color: transparent;
}

.peer:disabled ~ .peer-disabled\\:before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:disabled ~ .peer-disabled\\:after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:disabled:placeholder-shown ~ .peer-disabled\\:peer-placeholder-shown\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:animate-none {
    animation: none;
  }
}

@media (min-width: 640px) {

  .sm\\:order-2 {
    order: 2;
  }

  .sm\\:order-3 {
    order: 3;
  }

  .sm\\:order-4 {
    order: 4;
  }

  .sm\\:order-5 {
    order: 5;
  }

  .sm\\:order-6 {
    order: 6;
  }

  .sm\\:float-none {
    float: none;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mb-20 {
    margin-bottom: 5rem;
  }

  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .sm\\:ml-0 {
    margin-left: 0px;
  }

  .sm\\:ml-7 {
    margin-left: 1.75rem;
  }

  .sm\\:ml-\\[77px\\] {
    margin-left: 77px;
  }

  .sm\\:ml-auto {
    margin-left: auto;
  }

  .sm\\:mr-4 {
    margin-right: 1rem;
  }

  .sm\\:mr-7 {
    margin-right: 1.75rem;
  }

  .sm\\:mr-8 {
    margin-right: 2rem;
  }

  .sm\\:mr-\\[30px\\] {
    margin-right: 30px;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-16 {
    margin-top: 4rem;
  }

  .sm\\:mt-6 {
    margin-top: 1.5rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:h-\\[90px\\] {
    height: 90px;
  }

  .sm\\:w-\\[40px\\] {
    width: 40px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:grid-cols-\\[minmax\\(0\\2c 220px\\)_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: minmax(0,220px) minmax(0,1fr);
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-evenly {
    justify-content: space-evenly;
  }

  .sm\\:justify-stretch {
    justify-content: stretch;
  }

  .sm\\:gap-1 {
    gap: 0.25rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:p-0 {
    padding: 0px;
  }

  .sm\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .sm\\:pb-0 {
    padding-bottom: 0px;
  }

  .sm\\:pb-1 {
    padding-bottom: 0.25rem;
  }

  .sm\\:pb-2 {
    padding-bottom: 0.5rem;
  }

  .sm\\:pb-3 {
    padding-bottom: 0.75rem;
  }

  .sm\\:pb-4 {
    padding-bottom: 1rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:leading-normal {
    line-height: 1.5;
  }
}

@media (min-width: 768px) {

  .md\\:mb-4 {
    margin-bottom: 1rem;
  }

  .md\\:mt-auto {
    margin-top: auto;
  }

  .md\\:inline-block {
    display: inline-block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:w-3\\/4 {
    width: 75%;
  }

  .md\\:w-3\\/5 {
    width: 60%;
  }

  .md\\:w-5\\/6 {
    width: 83.333333%;
  }

  .md\\:w-\\[230px\\] {
    width: 230px;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .md\\:min-w-\\[66\\.666667\\%\\] {
    min-width: 66.666667%;
  }

  .md\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .md\\:min-w-\\[83\\.333333\\%\\] {
    min-width: 83.333333%;
  }

  .md\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .md\\:max-w-\\[66\\.666667\\%\\] {
    max-width: 66.666667%;
  }

  .md\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }

  .md\\:max-w-\\[83\\.333333\\%\\] {
    max-width: 83.333333%;
  }

  .md\\:flex-none {
    flex: none;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:items-stretch {
    align-items: stretch;
  }

  .md\\:gap-0 {
    gap: 0px;
  }

  .md\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .md\\:border-r {
    border-right-width: 1px;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
}

@media (min-width: 960px) {

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:mr-2 {
    margin-right: 0.5rem;
  }

  .lg\\:inline-block {
    display: inline-block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-auto {
    height: auto;
  }

  .lg\\:min-h-\\[520px\\] {
    min-height: 520px;
  }

  .lg\\:w-2\\/4 {
    width: 50%;
  }

  .lg\\:w-2\\/5 {
    width: 40%;
  }

  .lg\\:w-3\\/4 {
    width: 75%;
  }

  .lg\\:w-3\\/5 {
    width: 60%;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:min-w-\\[40\\%\\] {
    min-width: 40%;
  }

  .lg\\:min-w-\\[50\\%\\] {
    min-width: 50%;
  }

  .lg\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .lg\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .lg\\:max-w-\\[40\\%\\] {
    max-width: 40%;
  }

  .lg\\:max-w-\\[50\\%\\] {
    max-width: 50%;
  }

  .lg\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .lg\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }

  .lg\\:flex-none {
    flex: none;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:items-stretch {
    align-items: stretch;
  }

  .lg\\:justify-normal {
    justify-content: normal;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:bg-transparent {
    background-color: transparent;
  }

  .lg\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:pb-3 {
    padding-bottom: 0.75rem;
  }

  .lg\\:pl-7 {
    padding-left: 1.75rem;
  }

  .lg\\:pr-6 {
    padding-right: 1.5rem;
  }

  .lg\\:before\\:-bottom-\\[20px\\]::before {
    content: var(--tw-content);
    bottom: -20px;
  }

  .lg\\:before\\:-right-0::before {
    content: var(--tw-content);
    right: -0px;
  }

  .lg\\:before\\:-top-\\[20px\\]::before {
    content: var(--tw-content);
    top: -20px;
  }

  .lg\\:before\\:left-auto::before {
    content: var(--tw-content);
    left: auto;
  }

  .lg\\:after\\:-bottom-\\[20px\\]::after {
    content: var(--tw-content);
    bottom: -20px;
  }

  .lg\\:after\\:-right-0::after {
    content: var(--tw-content);
    right: -0px;
  }

  .lg\\:after\\:-top-\\[20px\\]::after {
    content: var(--tw-content);
    top: -20px;
  }

  .lg\\:after\\:bottom-auto::after {
    content: var(--tw-content);
    bottom: auto;
  }

  .lg\\:after\\:left-auto::after {
    content: var(--tw-content);
    left: auto;
  }

  .lg\\:after\\:top-0::after {
    content: var(--tw-content);
    top: 0px;
  }

  .lg\\:after\\:h-11::after {
    content: var(--tw-content);
    height: 2.75rem;
  }

  .lg\\:after\\:w-\\[3px\\]::after {
    content: var(--tw-content);
    width: 3px;
  }

  .lg\\:after\\:rounded-r-3xl::after {
    content: var(--tw-content);
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  .lg\\:after\\:rounded-t-none::after {
    content: var(--tw-content);
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }

  .lg\\:after\\:rounded-br-3xl::after {
    content: var(--tw-content);
    border-bottom-right-radius: 20px;
  }

  .lg\\:after\\:rounded-tl-none::after {
    content: var(--tw-content);
    border-top-left-radius: 0px;
  }

  .lg\\:after\\:rounded-tr-3xl::after {
    content: var(--tw-content);
    border-top-right-radius: 20px;
  }

  .lg\\:after\\:rounded-tr-none::after {
    content: var(--tw-content);
    border-top-right-radius: 0px;
  }

  .lg\\:after\\:py-3::after {
    content: var(--tw-content);
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .xl\\:mr-36 {
    margin-right: 9rem;
  }

  .xl\\:mt-0 {
    margin-top: 0px;
  }

  .xl\\:mt-12 {
    margin-top: 3rem;
  }

  .xl\\:block {
    display: block;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:max-w-\\[700px\\] {
    max-width: 700px;
  }

  .xl\\:flex-\\[2\\.5\\] {
    flex: 2.5 1;
  }

  .xl\\:basis-1\\/2 {
    flex-basis: 50%;
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[500px_auto\\] {
    grid-template-columns: 500px auto;
  }

  .xl\\:grid-cols-\\[650px_auto\\] {
    grid-template-columns: 650px auto;
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:gap-10 {
    gap: 2.5rem;
  }

  .xl\\:gap-16 {
    gap: 4rem;
  }

  .xl\\:gap-2 {
    gap: 0.5rem;
  }

  .xl\\:gap-7 {
    gap: 1.75rem;
  }

  .xl\\:pb-14 {
    padding-bottom: 3.5rem;
  }

  .xl\\:pb-4 {
    padding-bottom: 1rem;
  }

  .xl\\:pb-8 {
    padding-bottom: 2rem;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:w-1\\/3 {
    width: 33.333333%;
  }

  .\\32xl\\:w-1\\/4 {
    width: 25%;
  }

  .\\32xl\\:w-2\\/5 {
    width: 40%;
  }

  .\\32xl\\:w-3\\/4 {
    width: 75%;
  }

  .\\32xl\\:w-3\\/5 {
    width: 60%;
  }

  .\\32xl\\:min-w-\\[25\\%\\] {
    min-width: 25%;
  }

  .\\32xl\\:min-w-\\[33\\.333333\\%\\] {
    min-width: 33.333333%;
  }

  .\\32xl\\:min-w-\\[40\\%\\] {
    min-width: 40%;
  }

  .\\32xl\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .\\32xl\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .\\32xl\\:max-w-\\[25\\%\\] {
    max-width: 25%;
  }

  .\\32xl\\:max-w-\\[33\\.333333\\%\\] {
    max-width: 33.333333%;
  }

  .\\32xl\\:max-w-\\[40\\%\\] {
    max-width: 40%;
  }

  .\\32xl\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .\\32xl\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }
}

@media (max-width: 480px) {

  .xs\\:fixed {
    position: fixed;
  }

  .xs\\:bottom-0 {
    bottom: 0px;
  }

  .xs\\:top-0 {
    top: 0px;
  }

  .xs\\:z-10 {
    z-index: 10;
  }

  .xs\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .xs\\:mb-14 {
    margin-bottom: 3.5rem;
  }

  .xs\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .xs\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .xs\\:mb-8 {
    margin-bottom: 2rem;
  }

  .xs\\:mt-0 {
    margin-top: 0px;
  }

  .xs\\:mt-10 {
    margin-top: 2.5rem;
  }

  .xs\\:mt-12 {
    margin-top: 3rem;
  }

  .xs\\:mt-2 {
    margin-top: 0.5rem;
  }

  .xs\\:mt-8 {
    margin-top: 2rem;
  }

  .xs\\:mt-auto {
    margin-top: auto;
  }

  .xs\\:h-12 {
    height: 3rem;
  }

  .xs\\:max-h-screen {
    max-height: 100vh;
  }

  .xs\\:w-12 {
    width: 3rem;
  }

  .xs\\:w-\\[40px\\] {
    width: 40px;
  }

  .xs\\:w-full {
    width: 100%;
  }

  .xs\\:flex-col {
    flex-direction: column;
  }

  .xs\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .xs\\:items-center {
    align-items: center;
  }

  .xs\\:justify-center {
    justify-content: center;
  }

  .xs\\:justify-evenly {
    justify-content: space-evenly;
  }

  .xs\\:gap-0 {
    gap: 0px;
  }

  .xs\\:gap-2 {
    gap: 0.5rem;
  }

  .xs\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .xs\\:gap-5 {
    gap: 1.25rem;
  }

  .xs\\:overflow-auto {
    overflow: auto;
  }

  .xs\\:overflow-hidden {
    overflow: hidden;
  }

  .xs\\:whitespace-normal {
    white-space: normal;
  }

  .xs\\:border {
    border-width: 1px;
  }

  .xs\\:border-gray-200 {
    --tw-border-opacity: 1;
    border-color: rgb(238 238 238 / var(--tw-border-opacity));
  }

  .xs\\:p-5 {
    padding: 1.25rem;
  }

  .xs\\:pb-1 {
    padding-bottom: 0.25rem;
  }

  .xs\\:pb-24 {
    padding-bottom: 6rem;
  }

  .xs\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .xs\\:text-center {
    text-align: center;
  }

  .xs\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .xs\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .xs\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .xs\\:font-light {
    font-weight: 300;
  }

  .xs\\:font-normal {
    font-weight: 400;
  }
}

@media (min-width: 720px) {

  .mid\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .mid\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {

  .lgdef\\:mt-0 {
    margin-top: 0px;
  }

  .lgdef\\:flex-\\[1\\.5\\] {
    flex: 1.5 1;
  }

  .lgdef\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lgdef\\:flex-row {
    flex-direction: row;
  }

  .lgdef\\:gap-5 {
    gap: 1.25rem;
  }

  .lgdef\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

.\\[\\&\\+\\&\\]\\:border-t+.\\[\\&\\+\\&\\]\\:border-t {
  border-top-width: 1px;
}

.\\[\\&\\+div\\]\\:border-t-white+div {
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:relative::-moz-range-thumb {
  position: relative;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:z-20::-moz-range-thumb {
  z-index: 20;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:-mt-1::-moz-range-thumb {
  margin-top: -0.25rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:-mt-\\[3px\\]::-moz-range-thumb {
  margin-top: -3px;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-2\\.5::-moz-range-thumb {
  height: 0.625rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-3\\.5::-moz-range-thumb {
  height: 0.875rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-5::-moz-range-thumb {
  height: 1.25rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-2\\.5::-moz-range-thumb {
  width: 0.625rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-3\\.5::-moz-range-thumb {
  width: 0.875rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-5::-moz-range-thumb {
  width: 1.25rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:appearance-none::-moz-range-thumb {
  appearance: none;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:rounded-full::-moz-range-thumb {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:border-0::-moz-range-thumb {
  border-width: 0px;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:bg-white::-moz-range-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:ring-2::-moz-range-thumb {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:ring-current::-moz-range-thumb {
  --tw-ring-color: currentColor;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:\\[-webkit-appearance\\:none\\]::-moz-range-thumb {
  -webkit-appearance: none;
}

.\\[\\&\\:\\:-moz-range-track\\]\\:h-full::-moz-range-track {
  height: 100%;
}

.\\[\\&\\:\\:-moz-range-track\\]\\:rounded-full::-moz-range-track {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-moz-range-track\\]\\:bg-blue-gray-100::-moz-range-track {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-details-marker\\]\\:hidden::-webkit-details-marker {
  display: none;
}

.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:h-full::-webkit-slider-runnable-track {
  height: 100%;
}

.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:rounded-full::-webkit-slider-runnable-track {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:bg-blue-gray-100::-webkit-slider-runnable-track {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:relative::-webkit-slider-thumb {
  position: relative;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:z-20::-webkit-slider-thumb {
  z-index: 20;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:-mt-1::-webkit-slider-thumb {
  margin-top: -0.25rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:-mt-\\[3px\\]::-webkit-slider-thumb {
  margin-top: -3px;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-2\\.5::-webkit-slider-thumb {
  height: 0.625rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-3\\.5::-webkit-slider-thumb {
  height: 0.875rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-5::-webkit-slider-thumb {
  height: 1.25rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-2\\.5::-webkit-slider-thumb {
  width: 0.625rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-3\\.5::-webkit-slider-thumb {
  width: 0.875rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-5::-webkit-slider-thumb {
  width: 1.25rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:appearance-none::-webkit-slider-thumb {
  appearance: none;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:rounded-full::-webkit-slider-thumb {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:border-0::-webkit-slider-thumb {
  border-width: 0px;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-white::-webkit-slider-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:ring-2::-webkit-slider-thumb {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:ring-current::-webkit-slider-thumb {
  --tw-ring-color: currentColor;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:\\[-webkit-appearance\\:none\\]::-webkit-slider-thumb {
  -webkit-appearance: none;
}

.\\[\\&\\:hover\\+div\\]\\:border-t-white:hover+div {
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.\\[\\&\\>\\*\\:last-child\\>\\*\\:first-child\\]\\:p-0>*:last-child>*:first-child {
  padding: 0px;
}

.\\[\\&\\>\\*\\:last-child\\]\\:flex-row-reverse>*:last-child {
  flex-direction: row-reverse;
}

.\\[\\&\\>\\*\\:last-child\\]\\:rounded-b-2xl>*:last-child {
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}

.\\[\\&\\>\\*\\:last-child\\]\\:border-b>*:last-child {
  border-bottom-width: 1px;
}

.\\[\\&\\>\\*\\:not\\(\\:first-child\\)\\]\\:border-t>*:not(:first-child) {
  border-top-width: 1px;
}

.\\[\\&\\>\\:last-child\\]\\:border-none>:last-child {
  border-style: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,2DAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,2IAA2I;AAC3I;EACE,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,gCAAgC;EAChC,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,wBAAwB;EACxB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,wFAAwF;EACxF,wFAAwF;EACxF,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,oIAAoI;AACpI;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,gCAAgC;EAChC,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,gFAAgF;EAChF,iFAAiF;EACjF,cAAc;EACd,mBAAmB;AACrB;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,4BAA4B;IAChC;AACJ;;AAGE;;EAAA;IAAA;EAAyB;AAAA;;AAG3B;;;;;;;GAOG;;AAEH;IACI,mDAAmD;AACvD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;AACA,0HAA0H;AAC1H;EACE,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;IACI,iCAAiC;AACrC;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA,8GAA8G;AAC9G;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,wBAAwB;IACxB,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAzIA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,wBA0IA;EA1IA,wDA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,4BA0IA;EA1IA,wDA0IA;EA1IA;AA0IA;;AA1IA;EAAA,gBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,eA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,eA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,4DA0IA;EA1IA,oEA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,wBA0IA;EA1IA,wDA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,8BA0IA;EA1IA,wDA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,gBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,iBA0IA;EA1IA,iBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,4DA0IA;EA1IA,kEA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,+EA0IA;EA1IA,mGA0IA;EA1IA;AA0IA;;AA1IA;EAAA,uCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,wCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,wCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,wCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,uCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,uCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,uCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,wCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,uCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,uCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,uCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,wCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,wCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,uCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,uCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,wCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,uCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,uCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,wCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0CA0IA;EA1IA;AA0IA;;AA1IA;EAAA,gCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,6BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,4DA0IA;EA1IA,oEA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,gBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,iBA0IA;EA1IA,iBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,iCA0IA;EA1IA,+CA0IA;EA1IA;AA0IA;;AA1IA;EAAA,8BA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,2GA0IA;EA1IA,yGA0IA;EA1IA;AA0IA;;AA1IA;EAAA,2GA0IA;EA1IA,yGA0IA;EA1IA;AA0IA;;AA1IA;EAAA,2GA0IA;EA1IA,yGA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,eA0IA;EA1IA,eA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,iCA0IA;EA1IA,+CA0IA;EA1IA;AA0IA;;AA1IA;EAAA,gCA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,iCA0IA;EA1IA,+CA0IA;EA1IA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,8BA0IA;EA1IA;AA0IA;;AA1IA;;EAAA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;AAAA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,mBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,mBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,eA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,iCA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,0BA0IA;EA1IA;AA0IA;;AA1IA;EAAA,oBA0IA;EA1IA;AA0IA;;AA1IA;;EAAA;IAAA;EA0IA;AAAA;;AA1IA;;EAAA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA,gBA0IA;IA1IA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA,qBA0IA;IA1IA;EA0IA;;EA1IA;IAAA,gBA0IA;IA1IA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA,iBA0IA;IA1IA;EA0IA;;EA1IA;IAAA;EA0IA;AAAA;;AA1IA;;EAAA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA,oBA0IA;IA1IA;EA0IA;;EA1IA;IAAA,oBA0IA;IA1IA;EA0IA;AAAA;;AA1IA;;EAAA;IAAA,gBA0IA;IA1IA;EA0IA;;EA1IA;IAAA,iBA0IA;IA1IA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA,oBA0IA;IA1IA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA,6BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA,2BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA;EA0IA;;EA1IA;IAAA,0BA0IA;IA1IA,oBA0IA;IA1IA;EA0IA;AAAA;;AA1IA;;EAAA;IAAA,iBA0IA;IA1IA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;AAAA;;AA1IA;;EAAA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;AAAA;;AA1IA;;EAAA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA,gBA0IA;IA1IA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA,sBA0IA;IA1IA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA,eA0IA;IA1IA;EA0IA;;EA1IA;IAAA,mBA0IA;IA1IA;EA0IA;;EA1IA;IAAA,mBA0IA;IA1IA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;AAAA;;AA1IA;;EAAA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;AAAA;;AA1IA;;EAAA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA;EA0IA;;EA1IA;IAAA,oBA0IA;IA1IA;EA0IA;AAAA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,2GA0IA;EA1IA,yGA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,kBA0IA;EA1IA;AA0IA;;AA1IA;EAAA,2GA0IA;EA1IA,yGA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,sBA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA,gCA0IA;EA1IA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA;;AA1IA;EAAA;AA0IA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* broker-report-sync: semantic colour roles of the design mock (docs/design-system.md), RGB triplets so Tailwind opacity modifiers work. */\n:root {\n  --bg: 250 250 250;\n  --surface: 255 255 255;\n  --surface-alt: 242 242 242;\n  --surface-muted: 247 247 247;\n  --border: 226 226 226;\n  --text: 20 23 26;\n  --text-muted: 140 140 140;\n  --accent-solid: 8 162 186;\n  --accent-solid-hover: 10 142 163;\n  --success: 3 211 137;\n  --success-ink: 4 106 72;\n  --success-bg: 228 250 241;\n  --warn: 184 121 15;\n  --warn-bg: 253 241 222;\n  --warn-border: 240 214 168;\n  --danger: 194 59 59;\n  --danger-bg: 251 234 234;\n  --danger-border: 240 194 194;\n  --tl-new: 10 142 163;\n  --tl-old: 122 111 208;\n  --shadow-card: 0 1px 2px rgba(20, 23, 26, 0.04), 0 8px 24px -12px rgba(20, 23, 26, 0.12);\n  --shadow-pop: 0 2px 6px rgba(20, 23, 26, 0.06), 0 24px 48px -16px rgba(20, 23, 26, 0.28);\n  --scrim: 20 23 26;\n  --scrim-alpha: 0.28;\n}\n\n/* Dark values apply only with an explicit data-theme=\"dark\" on <html>: light is the default until the cabinet has a theme switch. */\n:root[data-theme=\"dark\"] {\n  --bg: 20 24 26;\n  --surface: 27 33 36;\n  --surface-alt: 34 42 45;\n  --surface-muted: 30 36 39;\n  --border: 50 60 64;\n  --text: 238 241 242;\n  --text-muted: 147 160 164;\n  --accent-solid: 47 195 222;\n  --accent-solid-hover: 84 207 230;\n  --success: 31 227 156;\n  --success-ink: 143 243 206;\n  --success-bg: 15 46 38;\n  --warn: 240 179 62;\n  --warn-bg: 51 37 8;\n  --warn-border: 90 63 15;\n  --danger: 240 113 107;\n  --danger-bg: 51 19 19;\n  --danger-border: 90 31 31;\n  --tl-new: 24 152 176;\n  --tl-old: 143 128 232;\n  --shadow-card: 0 1px 2px rgba(0, 0, 0, 0.3), 0 8px 24px -12px rgba(0, 0, 0, 0.5);\n  --shadow-pop: 0 2px 6px rgba(0, 0, 0, 0.35), 0 24px 48px -16px rgba(0, 0, 0, 0.7);\n  --scrim: 0 0 0;\n  --scrim-alpha: 0.45;\n}\n\n.page {\n    @media screen and (max-width: 1279px) {\n        padding: 60px 30px;\n    }\n    @media screen and (max-width: 639px) {\n        padding: 20px 5px;\n    }\n    @media screen and (min-width: 1280px) {\n        padding: 90px 30px 30px 77px;\n    }\n}\n\nhtml, body, #root {\n  @apply xs:overflow-hidden;\n}\n\n/* html {\n    height: -webkit-fill-available;\n}\n\nbody {\n    min-height: 100vh;\n    min-height: -webkit-fill-available;\n} */\n\n* {\n    -webkit-tap-highlight-color: transparent !important;\n}\n\n.rotate {\n    animation: rotate 2s linear infinite; \n}\n\n@keyframes rotate {\n    100% {\n        transform: rotate(360deg); \n    }\n}\n/* tax-planner numbers (mock `.num`, `table.pos td.num`): digits of one width, and a number in a table cell never wraps. */\n.num {\n  font-variant-numeric: tabular-nums;\n}\ntd.num, td .num {\n  white-space: nowrap;\n}\n\n/* SCR-06 panel of broker-report-sync opens with a fade-in. */\n.fade-in {\n    animation: fade-in 150ms ease-out;\n}\n\n@keyframes fade-in {\n    from {\n        opacity: 0;\n    }\n}\n\n/* ReportTimeline hints (mock `.tl-bar[data-tip]`): a dark tooltip above a bar, a coverage segment or a gap. */\n[data-tip]:hover {\n    z-index: 5;\n}\n\n[data-tip]:hover::after {\n    content: attr(data-tip);\n    position: absolute;\n    bottom: calc(100% + 8px);\n    left: 0;\n    width: max-content;\n    max-width: 240px;\n    white-space: normal;\n    background: rgb(var(--text));\n    color: rgb(var(--bg));\n    font-size: 11px;\n    font-weight: 600;\n    padding: 5px 8px;\n    border-radius: 8px;\n    pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
